import axios from "axios";
// import { toast } from 'react-toastify'

// quiz/stdresult

// {
// _id, name, topic, correctAns, percentage, grade
// }

// const api = "http://localhost:5000/";
const api = "https://api.jawanpakistan.com/";

const addassignment =
  (
    city,
    institute,
    batch,
    course,
    time,
    deadline,
    details,
    assignmentName,
    totalMarks,
    assignmentLink,
    toast
  ) =>
  async (dispatch) => {
    dispatch({ type: "ADD_ASSIGNMENT" });

    const obj = {
      city,
      institute,
      batch,
      course,
      time,
      deadline,
      details,
      assignmentName,
      totalMarks,
      assignmentLink,
    };

    const options = {
      method: "POST",
      headers: { Accept: "application/json" },
      data: obj,
      url: `${api}assignment/addassignment`,
    };

    axios(options)
      .then((res) => {
        console.log(res.data);
        dispatch({ type: "ADD_ASSIGNMENT_SUCCESS", payload: res.data.data });
        toast.success(res.data.message);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "ADD_ASSIGNMENT_ERROR",
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      });
  };

const getstddassignment =
  (city, institute, batch, course, time) => async (dispatch) => {
    dispatch({ type: "STD_GET_ASSIGNMENT" });

    const obj = {
      city,
      institute,
      batch,
      course,
      time,
    };

    const options = {
      method: "POST",
      headers: { Accept: "application/json" },
      data: obj,
      url: `${api}assignment/getstdasiign`,
    };

    axios(options)
      .then((res) => {
        console.log(res.data);
        dispatch({
          type: "STD_GET_ASSIGNMENT_SUCCESS",
          payload: res.data.data,
        });
        // toast(res.data.message)
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "STD_GET_ASSIGNMENT_ERROR",
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      });
  };

const getsingleassignment = (id) => async (dispatch) => {
  dispatch({ type: "GET_SINGLE_ASSIGNMENT", id });
};

const updatestudentassignment =
  (
    id,
    rollNo,
    assignmentName,
    details,
    assignmentDate,
    time,
    deadline,
    assignmentLink,
    toast
  ) =>
  async (dispatch) => {
    dispatch({ type: "UPDATE_STD_ASSIGNMENT" });

    const obj = {
      id,
      rollNo,
      assignmentName,
      details,
      assignmentDate,
      time,
      deadline,
      assignmentLink,
    };

    const options = {
      method: "PUT",
      headers: { Accept: "application/json" },
      data: obj,
      url: `${api}assignment/stdupdateassi`,
    };

    axios(options)
      .then((res) => {
        console.log(res.data);
        dispatch({
          type: "UPDATE_STD_ASSIGNMENT_SUCCESS",
          payload: res.data.data,
        });
        toast.success(res.data.message);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "UPDATE_STD_ASSIGNMENT_ERROR",
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      });
  };

export {
  addassignment,
  getstddassignment,
  getsingleassignment,
  updatestudentassignment,
};
